import React, { Component } from 'react';
import {Link, NavLink} from 'react-router-dom';
import $ from 'jquery';
import {Api} from '../../../utils/Variables';

import {Row, Col, Card} from 'react-bootstrap';

import PsContext from '../../context/PsContext';
import menus from './menus';

class BottomTabs extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			
		}
		
	}
	
	componentDidMount(){
		
	}
	
	render(){

		
		return(
			<React.Fragment>
				 <div className="footer-nav-area" id="footerNav">
				  <div className="container h-100 px-0">
					<div className="suha-footer-nav h-100">
					  <ul className="h-100 d-flex align-items-center justify-content-between ps-0">
						{menus.map((item,i)=>{
							return <li className="">
								<NavLink to={item.to} >
									<i className={item.icon} ></i>
									{item.name}
								</NavLink>
							</li>;
						})
						}
					  </ul>
					</div>
				  </div>
				</div>
			</React.Fragment>
		);
	}
	
}
export default BottomTabs;
